import { listPageSelect_template, registerListPageSelectMountBinding } from '~/components/templates/listPageSelect_template';
import { html, LpButton, LpEmpty, LpIcon, LpTooltip } from '~/design-system';
export const QUESTION_BANK_FIELD_TOOLTIP_TITLE = 'Question bank fields';
export const QUESTION_BANK_FIELD_TOOLTIP_CONTENT = html `
    <p><strong>Active</strong><br>Enable or disable this question bank.</p>
    <p><strong>Conditional service fields</strong><br>Show Branch, Pay Grade, and Separation Date only when Prior Service is selected.</p>
    <p><strong>Pages</strong><br>Organize the questions users will see in this bank.</p>
`;
/** Register the shared listPageSelect Knockout template once. */
export function initQuestionBankAvailableQuestionSelect(viewModel, caller) {
    registerListPageSelectMountBinding();
    const seed = new listPageSelect_template('questionBankAvailableQuestionSelectSeed', viewModel, caller);
    seed.includeTemplate();
}
export function renderQuestionBankUniqueIdentifierLabel() {
    const tooltip = LpTooltip({
        label: QUESTION_BANK_FIELD_TOOLTIP_TITLE,
        content: QUESTION_BANK_FIELD_TOOLTIP_CONTENT,
        side: 'bottom',
        align: 'start',
        className: 'question-bank-field-tooltip',
    });
    return html `
        <label class="form-label profile-field__label question-bank-field-label">
            <span>Unique Identifier</span>
            ${tooltip}
        </label>
    `;
}
function renderQuestionBankQuestionList() {
    return html `
        <div class="question-bank-question-list" aria-label="Assigned questions">
            <div class="question-bank-question-list__header">
                <h4>Questions</h4>
            </div>
            <div class="question-bank-question-list__items" data-bind="foreach: pageXrefs">
                <div
                    class="question-bank-question-item"
                    data-bind="dropZone: { accepts: $parent.dragZoneId, drop: function (dragged) { $parents[1].onQuestionDragDrop($parent, dragged, $data); } }"
                >
                    <span
                        class="question-bank-drag-handle question-bank-question-item__drag"
                        role="button"
                        tabindex="0"
                        aria-label="Drag to reorder question"
                        data-bind="dragZone: { name: $parent.dragZoneId, data: $data }"
                    >
                        ${LpIcon({ name: 'dots-six-vertical', size: 18, className: 'question-bank-drag-handle__icon' })}
                    </span>
                    <span class="question-bank-question-item__index" data-bind="text: $index() + 1"></span>
                    <span class="question-bank-question-item__name" data-bind="text: question ? question.questionName : ''"></span>
                    ${LpButton({
        ariaLabel: 'Remove question',
        prefixIcon: 'trash',
        size: 'sm',
        shape: 'square',
        variant: 'ghost',
        className: 'question-bank-icon-danger question-bank-question-item__delete',
        attributes: {
            'data-bind': 'click: function() { $parents[1].onClickRemoveQuestion($parent, $data); }',
        },
    })}
                </div>
            </div>
            <div class="question-bank-question-list__empty" data-bind="visible: pageXrefs().length === 0">
                ${LpEmpty({
        title: 'No questions assigned',
        description: 'Add a question to this page to build the question bank flow.',
        icon: 'question',
        size: 'sm',
    })}
            </div>
        </div>
    `;
}
function renderQuestionBankAvailableQuestionSelect() {
    return html `
        <div class="form-group question-bank-picker__select">
            <label class="form-label profile-field__label">Available question</label>
            <div
                class="question-bank-available-select"
                data-bind="listPageSelectMount: questionSelectInstance"
            ></div>
        </div>
    `;
}
export function renderQuestionBankPagesSection() {
    return `
        <div class="question-bank-pages">
            <div class="question-bank-page-list-header">
                <div>
                    <h3>Pages</h3>
                    <p>Organize the page order and assigned questions for this bank.</p>
                </div>

                ${LpButton({
        label: 'Add Page',
        prefixIcon: 'plus',
        size: 'base',
        variant: 'secondary',
        attributes: {
            'data-bind': 'click: onClickAddPage',
        },
    })}
            </div>

            <div class="row-pages" data-bind="foreach: pages">
                <details
                    class="question-bank-page-card"
                    open
                    data-bind="dropZone: { accepts: 'question-bank-pages', drop: function (dragged) { $parent.onPageDragDrop(dragged, $data); } }"
                >
                    <summary class="question-bank-page-header">
                        <span
                            class="question-bank-page-drag-handle"
                            role="button"
                            tabindex="0"
                            aria-label="Drag to reorder page"
                            data-bind="dragZone: { name: 'question-bank-pages', data: $data }"
                        >
                            ${LpIcon({ name: 'dots-six-vertical', size: 18, className: 'question-bank-drag-handle__icon' })}
                        </span>
                        <span class="question-bank-page-header__title" data-bind="text: 'Page ' + ($index() + 1)"></span>
                        <span class="question-bank-page-header__meta" data-bind="text: pageXrefs().length + ' ' + (pageXrefs().length === 1 ? 'question' : 'questions')"></span>
                        ${LpButton({
        ariaLabel: 'Delete page',
        prefixIcon: 'trash',
        size: 'sm',
        shape: 'square',
        variant: 'ghost',
        className: 'question-bank-icon-danger question-bank-page-header__delete',
        attributes: {
            'data-bind': 'click: function (_page, event) { event.stopPropagation(); $parent.onClickDeletePage($data); return false; }',
        },
    })}
                        ${LpIcon({ name: 'caret-down', size: 18, className: 'question-bank-page-header__icon' })}
                    </summary>

                    <div class="question-bank-page-body">
                        <div class="question-bank-picker">
                            ${renderQuestionBankAvailableQuestionSelect()}
                            <div class="question-bank-picker__actions">
                                ${LpButton({
        label: 'Add selected question',
        prefixIcon: 'plus',
        size: 'base',
        variant: 'secondary',
        attributes: {
            'data-bind': 'click: $parent.onClickAddQuestion',
        },
    })}
                            </div>
                        </div>
                        <div class="question-bank-empty" data-bind="visible: $parent.availableQuestions().length === 0">No available questions found.</div>
                        ${renderQuestionBankQuestionList()}
                    </div>
                </details>
            </div>

            <div class="question-bank-empty-state" data-bind="visible: pages().length === 0">
                <strong>No pages configured yet.</strong>
                <span>Click Add Page to start building this question bank.</span>
            </div>
        </div>
    `;
}
let questionBankPageDragZoneCounter = 0;
function createPageDragZoneId() {
    questionBankPageDragZoneCounter += 1;
    return `question-bank-page-${questionBankPageDragZoneCounter}`;
}
export class QuestionBankPagesMixin {
    normalizePages(pages, parentVm, caller) {
        return (pages || []).map((page) => this.createPageModel(page, parentVm, caller));
    }
    mapQuestionForDisplay(question) {
        if (!question) {
            return question;
        }
        const label = question.configuration && question.configuration.label
            ? question.configuration.label
            : '';
        return {
            ...question,
            id: question.id ? Number(question.id) : null,
            questionName: label ? label : 'Question #' + (question.id || ''),
        };
    }
    setAvailableQuestionsOnVm(vm, questions) {
        vm.availableQuestions((questions || []).map((question) => this.mapQuestionForDisplay(question)));
        this.syncAvailableQuestionSelectOptions(vm);
    }
    buildPagesPayload(pages) {
        return (pages || []).map((page, pageIndex) => ({
            id: page.id || null,
            pageNumber: pageIndex,
            pageXrefs: (page.pageXrefs() || []).map((xref, xrefIndex) => ({
                id: xref.id || null,
                displayOrder: xrefIndex,
                question: xref.question,
            })),
        }));
    }
    addPageToVm(vm, caller) {
        vm.pages.push(this.createPageModel({
            id: null,
            pageNumber: vm.pages().length,
            pageXrefs: [],
        }, vm, caller));
    }
    deletePageFromVm(vm, page) {
        vm.pages.remove(page);
    }
    addQuestionToPage(vm, page) {
        const questionId = Number(page.selectedQuestionId());
        if (!questionId) {
            alert('Select a question to add.');
            return;
        }
        if ((page.pageXrefs() || []).some((xref) => xref.question && Number(xref.question.id) === questionId)) {
            alert('This question is already assigned to this page.');
            return;
        }
        const question = this.findQuestionById(vm, questionId);
        if (!question) {
            alert('Unable to find the selected question.');
            return;
        }
        page.pageXrefs.push({
            id: null,
            displayOrder: page.pageXrefs().length,
            question: this.mapQuestionForDisplay(question),
        });
        page.selectedQuestionId('');
    }
    removeQuestionFromPage(page, xref) {
        page.pageXrefs.remove(xref);
    }
    moveQuestionOnPage(page, xref, direction) {
        const list = page.pageXrefs();
        const index = list.indexOf(xref);
        const nextIndex = index + direction;
        if (index < 0 || nextIndex < 0 || nextIndex >= list.length) {
            return;
        }
        list.splice(index, 1);
        list.splice(nextIndex, 0, xref);
        page.pageXrefs.valueHasMutated();
    }
    reorderQuestionOnPage(page, draggedXref, targetXref) {
        if (!page || !draggedXref || !targetXref || draggedXref === targetXref) {
            return;
        }
        const list = page.pageXrefs();
        const fromIndex = list.indexOf(draggedXref);
        const toIndex = list.indexOf(targetXref);
        if (fromIndex < 0 || toIndex < 0 || fromIndex === toIndex) {
            return;
        }
        list.splice(fromIndex, 1);
        list.splice(toIndex, 0, draggedXref);
        page.pageXrefs.valueHasMutated();
    }
    reorderPageInVm(vm, draggedPage, targetPage) {
        if (!vm || !draggedPage || !targetPage || draggedPage === targetPage) {
            return;
        }
        const pages = vm.pages();
        const fromIndex = pages.indexOf(draggedPage);
        const toIndex = pages.indexOf(targetPage);
        if (fromIndex < 0 || toIndex < 0 || fromIndex === toIndex) {
            return;
        }
        pages.splice(fromIndex, 1);
        pages.splice(toIndex, 0, draggedPage);
        vm.pages.valueHasMutated();
    }
    findQuestionById(vm, questionId) {
        const questions = vm.availableQuestions() || [];
        for (const question of questions) {
            if (Number(question.id) === questionId) {
                return question;
            }
        }
        return null;
    }
    syncAvailableQuestionSelectOptions(vm) {
        const options = this.toAvailableQuestionSelectOptions(vm.availableQuestions() || []);
        (vm.pages() || []).forEach((page) => {
            if (page.questionSelectInstance) {
                page.questionSelectInstance.setOptions(options);
            }
        });
    }
    createPageModel(page, parentVm, caller) {
        const dragZoneId = page.dragZoneId || createPageDragZoneId();
        const selectedQuestionId = ko.observable('');
        const model = {
            id: page.id || null,
            pageNumber: page.pageNumber || 0,
            dragZoneId,
            selectedQuestionId,
            pageXrefs: ko.observableArray((page.pageXrefs || []).map((xref) => ({
                ...xref,
                question: this.mapQuestionForDisplay(xref.question),
            }))),
            questionSelectKey: '',
            questionSelectInstance: null,
        };
        this.attachAvailableQuestionSelect(model, parentVm, caller);
        if (typeof parentVm.availableQuestions === 'function' && model.questionSelectInstance) {
            model.questionSelectInstance.setOptions(this.toAvailableQuestionSelectOptions(parentVm.availableQuestions() || []));
        }
        return model;
    }
    attachAvailableQuestionSelect(page, parentVm, caller) {
        // Keep ids identifier-safe (Partner/Transmission style — no hyphens).
        const selectKey = `qbAvailableQuestion${String(page.dragZoneId).replace(/\W/g, '')}`;
        const select = new listPageSelect_template(selectKey, parentVm, caller);
        select.setLabel('Available Question');
        select.setFormField(true);
        select.bindValue(page.selectedQuestionId);
        page.questionSelectKey = selectKey;
        page.questionSelectInstance = select;
    }
    toAvailableQuestionSelectOptions(questions) {
        return (questions || [])
            .filter((question) => question && question.id !== null && typeof question.id !== 'undefined')
            .map((question) => ({
            id: String(question.id),
            name: String(question.questionName || ('Question #' + question.id)),
        }));
    }
}
